/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RefundedInputs */

const cs_enum_refunded = /** @type {(inputs: Enum_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vráceno`)
};

const en_enum_refunded = /** @type {(inputs: Enum_RefundedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refunded`)
};

/**
* | output |
* | --- |
* | "Refunded" |
*
* @param {Enum_RefundedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_refunded = /** @type {((inputs?: Enum_RefundedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RefundedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_refunded(inputs)
	return cs_enum_refunded(inputs)
});